import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { AccountAttributeStore, AccountProfile, AccountProfileEffects, AccountProfileStore, metaReducers } from '@qid/common';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import {
  ApiCreditService,
  AuthEffects,
  AuthFeature,
  CollectionTemplateEffects,
  CollectionTemplateFeature,
  DocumentAccessService,
  DocumentsEffects,
  DocumentsFeature,
  IntegrationConfigurationEffects,
  IntegrationConfigurationStore,
  OrganisationRelationshipEffects,
  OrganisationService,
  OrganisationUserEffects,
  OrganisationUserFeature,
  OrgRelationshipStore,
  RestService,
  ScannersEffects,
  ScannersFeature,
  SharesDataRepository,
  SharesEffects,
  SharesFeature,
  SidEffects,
  SidFeature,
  UsersEffects,
  UserService,
  UsersFeature,
  AppVmsService
} from '@qid/common';
import { DisplayService } from '@qid/core';
import { ENVIRONMENT, setEnv } from '@qid/env';
import { environment } from './environments/environment';

setEnv(environment);

bootstrapApplication(AppComponent, {
  providers: [
    // Routing
    provideRouter(routes),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },

    // UI Framework
    provideIonicAngular({ mode: 'ios' }),
    provideAnimations(),

    // State Management
    provideStore({
      [AuthFeature.AUTH_FEATURE_KEY]: AuthFeature.authReducer,
      [OrganisationUserFeature.ORGANISATION_USER_FEATURE_KEY]: OrganisationUserFeature.organisationUserReducer,
      [UsersFeature.USERS_FEATURE_KEY]: UsersFeature.usersReducer,
      [SharesFeature.SHARES_FEATURE_KEY]: SharesFeature.sharesReducer,
      [CollectionTemplateFeature.COLLECTION_TEMPLATE_FEATURE_KEY]: CollectionTemplateFeature.collectionTemplateReducer,
      [DocumentsFeature.DOCUMENTS_FEATURE_KEY]: DocumentsFeature.documentsReducer,
      [SidFeature.SID_FEATURE_KEY]: SidFeature.sidReducer,
      [ScannersFeature.SCANNERS_FEATURE_KEY]: ScannersFeature.scannersReducer,
      [OrgRelationshipStore.featureKey]: OrgRelationshipStore.reducer.recordReducer,
      [AccountAttributeStore.featureKey]: AccountAttributeStore.reducer.recordReducer,
      [AccountProfileStore.featureKey]: AccountProfileStore.reducer.recordReducer,
    }, { metaReducers }),
    provideEffects([
      AuthEffects,
      OrganisationUserEffects,
      UsersEffects,
      SharesEffects,
      CollectionTemplateEffects,
      DocumentsEffects,
      SidEffects,
      ScannersEffects,
      OrganisationRelationshipEffects,
      IntegrationConfigurationEffects,
      AccountProfileEffects
    ]),
    provideStoreDevtools(),

    // HTTP
    provideHttpClient(),

    // Services
    UserService,
    RestService,
    DisplayService,
    DatePipe,
    OrganisationService,
    DocumentAccessService,
    ApiCreditService,
    AppVmsService,
    SharesDataRepository,

    // Environment
    { provide: ENVIRONMENT, useValue: environment }
  ],
}).catch((err) => console.error(err));
